export function LockIcon() {
  return (
    <svg viewBox="344.28 415.17 121.45 164.61">
      <path
        fill="#fff6f5"
        d="M459.664 481.902h-8.394v-20.41c.03-25.547-20.743-46.32-46.286-46.32-25.546 0-46.32 20.773-46.32 46.32v20.41h-8.363a6.027 6.027 0 0 0-6.024 6.024v85.86c0 3.292 2.7 5.991 6.024 5.991h109.394a6.03 6.03 0 0 0 6.028-6.027v-85.824c-.036-3.324-2.735-6.024-6.059-6.024m-88.953-20.41c0-18.894 15.375-34.27 34.273-34.27 18.895 0 34.27 15.376 34.27 34.27v20.41H370.71Zm40.297 73.676v15.836a6.027 6.027 0 0 1-12.051 0v-15.836c-4.144-2.172-6.977-6.52-6.977-11.488 0-7.176 5.825-12.973 12.97-12.973 7.175 0 12.972 5.828 12.972 12.973.066 4.968-2.766 9.316-6.914 11.488m0 0"
      ></path>
    </svg>
  );
}
